(function () {
  const BUTTON_SELECTOR = '.btn-xshare-sp[data-xshare-button]';

  const escapeHtml = (value = '') =>
    String(value).replace(/[&<>"']/g, (char) =>
      ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      })[char]
    );

  const ensureModal = (state) => {
    const { overlayId, modalId, discountAmountText, bannerImageEscaped } = state;

    document.getElementById(overlayId)?.remove();
    document.getElementById(modalId)?.remove();

    const overlay = document.createElement('div');
    overlay.className = 'xshare-modal__overlay';
    overlay.id = overlayId;
    overlay.hidden = true;

    const modal = document.createElement('div');
    modal.className = 'xshare-modal';
    modal.id = modalId;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', `${modalId}-title`);
    modal.hidden = true;

    modal.innerHTML = `
      <div class="xshare-modal__sp">
        <div class="xshare-modal__panel">
          <div class="xshare-modal__container">
            <button class="xshare-modal__close" id="${modalId}-close" aria-label="閉じる">×</button>
            <div class="xshare-modal__header">
              <div class="xshare-modal__title" id="${modalId}-title">Xでシェア＆クーポン受け取り</div>
            </div>

            <div class="xshare-modal__body">
              <div class="xshare-banner">
                <img src="https://cdn.shopify.com/s/files/1/0925/7805/4507/files/c_xshare.webp?v=1761995908" alt="Xシェアキャンペーン">
              </div>

              <p class="xshare-modal__description">
                <strong class="xshare-modal__description-title">受講の意気込みをXでポストして、この講座に使える${discountAmountText}円割引クーポンをもらおう！</strong>
              </p>

              <div class="xshare-actions">
                <button class="btn-primary" id="${modalId}-go-twitter" type="button">
                  Xでシェアしてクーポンを受け取る
                </button>

                <div class="xshare-inline-note" id="${modalId}-share-note" hidden>
                  Xでのシェアありがとうございます。完了したらチェックを入れてください。
                </div>

                <label class="xshare-check">
                  <input class="xshare-checkbox" type="checkbox" id="${modalId}-checked" disabled>
                  <span>Xでシェアしました</span>
                </label>

                <button class="btn-primary" id="${modalId}-claim" type="button" disabled>
                  クーポンコードを受け取る
                </button>

                <div class="small-note" id="${modalId}-msg"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    return {
      overlay,
      modal,
      closeBtn: modal.querySelector(`#${modalId}-close`),
      goXBtn: modal.querySelector(`#${modalId}-go-twitter`),
      chkBox: modal.querySelector(`#${modalId}-checked`),
      claimBtn: modal.querySelector(`#${modalId}-claim`),
      msg: modal.querySelector(`#${modalId}-msg`),
      inlineMsg: modal.querySelector(`#${modalId}-share-note`),
    };
  };

  const initButton = (btn) => {
    if (!btn || btn.dataset.xshareInit === 'true') return;
    btn.dataset.xshareInit = 'true';

    const buttonData = btn.dataset;

    const state = {
      email: buttonData.email || '',
      customerId: buttonData.customerId || '',
      customerName: buttonData.customerName || '',
      shareText: buttonData.productTitle || '',
      shareUrl: buttonData.productUrl || '',
      productUrl: buttonData.productPath || buttonData.productUrl || '',
      productId: buttonData.productId || '',
      discountAmount: buttonData.discountAmount || '',
      shopDomain: buttonData.shopDomain || window.location.hostname,
      locale: (document.documentElement.lang || 'ja').toLowerCase(),
    };

    state.discountAmountText = escapeHtml(state.discountAmount || '');
    state.overlayId = `xshare-overlay-sp-${state.productId || 'default'}`;
    state.modalId = `xshare-modal-sp-${state.productId || 'default'}`;
    state.storageKey = `xshare_claimed_${state.productId}_${state.customerId}`;

    const { overlay, modal, closeBtn, goXBtn, chkBox, claimBtn, msg, inlineMsg } = ensureModal(state);

    const toast = (text, variant = 'info', target = 'bottom') => {
      if (target === 'inline') {
        if (!inlineMsg) return;
        if (!text) {
          inlineMsg.hidden = true;
          inlineMsg.textContent = '';
          inlineMsg.className = 'xshare-inline-note';
          inlineMsg.classList.remove('is-visible', 'success-note', 'error-note');
          return;
        }

        inlineMsg.hidden = false;
        inlineMsg.textContent = text;
        inlineMsg.className = 'xshare-inline-note' + (variant === 'success' ? ' success-note' : variant === 'error' ? ' error-note' : '');
        inlineMsg.classList.add('is-visible');
        return;
      }

      if (!msg) return;
      msg.textContent = text || '';
      msg.className = 'small-note' + (variant === 'success' ? ' success-note' : variant === 'error' ? ' error-note' : '');
    };

    const assertLoggedIn = () => {
      if (!state.email || !state.customerId) {
        alert('クーポン送付にはログインが必要です。ログイン後にもう一度お試しください。');
        const ret = encodeURIComponent(state.productUrl || '/');
        window.location.href = `/account/login?return_url=${ret}`;
        btn.dataset.xshareInit = '';
        return false;
      }
      return true;
    };

    let xClicked = false;
    let posting = false;

    btn.addEventListener('click', (event) => {
      event.preventDefault();
      if (!assertLoggedIn()) return;

      const storageKey = state.storageKey;
      const claimedAt = localStorage.getItem(storageKey);

      if (claimedAt) {
        const claimedDate = new Date(claimedAt).toLocaleDateString('ja-JP');
        alert(`このクーポンは既に発行済みです（${claimedDate}）。\n\nメールボックスをご確認いただくか、受信できていない場合はサポートまでお問い合わせください。`);
        btn.dataset.xshareInit = '';
        return;
      }

      xClicked = false;
      chkBox.checked = false;
      chkBox.disabled = true;
      claimBtn.disabled = true;
      goXBtn?.classList.remove('btn-primary--clicked');
      toast('', 'info');
      toast('', 'info', 'inline');

      modal.hidden = false;
      overlay.hidden = false;
      modal.style.display = 'flex';
      overlay.style.display = 'block';
      document.body.style.overflow = 'hidden';
    });

    const closeModal = () => {
      modal.hidden = true;
      overlay.hidden = true;
      modal.style.display = 'none';
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    };

    closeBtn?.addEventListener('click', closeModal);
    overlay?.addEventListener('click', (event) => {
      if (event.target === overlay) closeModal();
    });

    goXBtn?.addEventListener('click', () => {
      if (!assertLoggedIn()) return;

      const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(state.shareText)}&url=${encodeURIComponent(state.shareUrl)}`;
      window.open(tweetUrl, '_blank', 'noopener');

      xClicked = true;
      chkBox.disabled = false;
      goXBtn.classList.add('btn-primary--clicked');
      toast('', 'info');
      toast('Xでのシェアありがとうございます。完了したらチェックを入れてください。', 'success', 'inline');
    });

    chkBox?.addEventListener('change', () => {
      claimBtn.disabled = !(xClicked && chkBox.checked);
    });

    claimBtn?.addEventListener('click', async () => {
      if (!assertLoggedIn()) return;
      if (!xClicked || !chkBox.checked || posting) return;

      if (localStorage.getItem(state.storageKey)) {
        toast('このクーポンは既に発行済みです。メールをご確認ください。', 'error');
        claimBtn.disabled = false;
        posting = false;
        return;
      }

      posting = true;
      claimBtn.disabled = true;
      toast('クーポンを発行しています。少々お待ちください…');

      const shareToken = (window.crypto?.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(16).slice(2)}`;

      try {
        const res = await fetch('https://hook.us1.make.com/11sovkp5k35evuepaw9x7mb2rkfx9kw7', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          keepalive: true,
          body: JSON.stringify({
            event: 'x_share_claim',
            shop: state.shopDomain,
            product_url: state.shareUrl,
            product_title: state.shareText,
            product_id: state.productId,
            customer_email: state.email,
            customer_id: state.customerId,
            customer_name: state.customerName,
            discount_amount: state.discountAmount,
            locale: state.locale,
            share_token: shareToken,
            ts: new Date().toISOString(),
          }),
        });

        let json = {};
        try {
          json = await res.json();
        } catch (error) {
          console.warn('xshare-sp: JSON parse error', error);
        }

        if (res.ok && json.status === 'success') {
          localStorage.setItem(state.storageKey, new Date().toISOString());

          if (json.coupon_code) {
            toast(`クーポン発行に成功しました。コード：${json.coupon_code}（メールでもお送りします）`, 'success');
          } else {
            toast('クーポンの発行を受け付けました。間もなくメールが届きます。', 'success');
          }

          posting = false;
        } else if (json.status === 'duplicate') {
          localStorage.setItem(state.storageKey, new Date().toISOString());
          toast('このクーポンは既に発行済みです。メールをご確認ください。', 'error');
          claimBtn.disabled = false;
          posting = false;
        } else {
          toast('発行に失敗しました。時間をおいて再度お試しください。', 'error');
          claimBtn.disabled = false;
          posting = false;
        }
      } catch (error) {
        console.error('xshare-sp: request failed', error);
        toast('送信に失敗しました。ネットワークをご確認のうえ再試行してください。', 'error');
        claimBtn.disabled = false;
        posting = false;
      }
    });
  };

  const init = (scope = document) => {
    if (!scope) return;
    const buttons = scope.querySelectorAll(BUTTON_SELECTOR);
    buttons.forEach((btn) => initButton(btn));
  };

  document.addEventListener('DOMContentLoaded', () => init(document));

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => init(event.target));
  document.addEventListener('product-info:loaded', () => init(document));
})();
